module.exports = __webpack_public_path__ + "static/media/no-video.cf71cc3b.png";